import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import info from "../../Assets/info.svg";

interface TooltipProps {
    text: React.ReactNode;
    icon?: IconProp;
    imgSmall?: boolean;
    className?: string;
    onClick?: () => void;
}

const Tooltip: React.FC<TooltipProps> = ({ text, icon, imgSmall, className, onClick }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLDivElement | null>(null);

    function handleClick() {
        setOpen(false);
        anchorRef.current?.blur();
        if (onClick) {
            onClick();
        }

    }

    return (
        <div className={`relative flex items-center justify-center ${className}`}>
            <div
                tabIndex={0}
                onFocus={() => setOpen(true)}
                onBlur={() => setOpen(false)}
                ref={anchorRef}
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                className={`${onClick ? 'cursor-pointer' : 'cursor-help'} flex items-center justify-center group`}
                onClick={handleClick}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleClick();
                    }
                }}
            >
                {icon ? (
                    <FontAwesomeIcon icon={icon} className={`${imgSmall ? "w-4.5 h-4.5" : "w-6 h-6"} opacity-60`} />
                ) : (
                    <img src={info} className={`${imgSmall ? "w-4.5 h-4.5" : "w-6 h-6"} opacity-60`} alt="info" />
                )}
            </div>

            {open && (
                <div className={`absolute bottom-full mb-2 flex flex-col items-center pointer-events-none ${imgSmall ? 'w-[300px]' : 'w-[400px]'} z-[10]`}>
                    <div className="bg-black w-3 h-3 transform rotate-45 z-[10] absolute -bottom-1" />
                    <div className="p-2 bg-black text-white rounded-md shadow-2xl text-sm z-[10] relative">
                        {text}
                    </div>
                </div>
            )
            }
        </div>
    );
};

export default Tooltip;
